
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.9 11.7h21.9v2.5H12.9zM12.9 17.1h21.9v2.5H12.9zM12.9 25.8h15.4v2.5H12.9zM12.9 31.3h6.7v2.5h-6.7zM12.9 36.8h8.4v2.5h-8.4z"}}),_c('g',[_c('path',{attrs:{"d":"M34.9 46.8H6.5V4.3h35v21.9H39V6.8H9v37.5h23.6z"}})]),_c('g',[_c('path',{attrs:{"d":"M38.3 46.8l-8.7-9.7h4.9v-8.3h7.7v8.3h4.9l-8.8 9.7zm-3.1-7.2l3.1 3.5 3.1-3.5h-1.8v-8.3H37v8.3h-1.8z"}})])])
          )
        }
      }
    